import { useMemo } from 'react'

import { Stack, Typography } from '@mui/material'

import { NotificationContent } from './NotificationContent'
import { NotificationSubject } from './NotificationSubject'

import { useController } from '../../hooks/useController'
import { useTexts } from './useTexts'

export function Body() {
  const { data } = useController()
  const { bodyPlainText } = data

  const texts = useTexts()
  const rows = useMemo(() => bodyPlainText.split('\n'), [bodyPlainText])

  return (
    <Stack spacing={2}>
      <Typography variant="subtitle3">{texts.bodyTitle}</Typography>
      <Stack spacing={1}>
        {data.kind === 'EMAIL' && <NotificationSubject data={data} />}
        <NotificationContent rows={rows} />
      </Stack>
    </Stack>
  )
}
